export default __webpack_public_path__ + "static/media/request-menu.874d8685.svg";